"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLotteryGameUpdateInputSchema = exports.APosLotteryGameCreateInputSchema = exports.APosLotteryGameSchema = exports.APosLotteryNumberRangeSchema = exports.APosLotteryDrawScheduleSchema = exports.APosLotteryGameCategorySchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosLotteryGameCategorySchema = zod_1.z.enum(['scratch_off', 'draw_game']);
exports.APosLotteryDrawScheduleSchema = zod_1.z.enum(['daily', 'twice_daily', 'weekly', 'multi_weekly']);
exports.APosLotteryNumberRangeSchema = zod_1.z.object({
    min: zod_1.z.number().int().min(0),
    max: zod_1.z.number().int().min(0),
    picks: zod_1.z.number().int().min(1),
});
exports.APosLotteryGameSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    gameId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(200),
    gameNumber: zod_1.z.string().min(1).max(50).optional(), // optional for draw games
    upc: zod_1.z.string().optional(),
    ticketDirection: zod_1.z.enum(['up', 'down']).optional(),
    ticketPrice: zod_1.z.number().int().min(0).describe('Ticket price in cents'),
    gameCategory: exports.APosLotteryGameCategorySchema,
    // Draw game fields
    drawSchedule: exports.APosLotteryDrawScheduleSchema.optional(),
    drawDays: zod_1.z.array(zod_1.z.string()).optional(),
    drawTimes: zod_1.z.array(zod_1.z.string()).optional(),
    numberRange: exports.APosLotteryNumberRangeSchema.optional(),
    hasQuickPick: zod_1.z.boolean().optional(),
    hasBonusBall: zod_1.z.boolean().optional(),
    bonusRange: exports.APosLotteryNumberRangeSchema.optional(),
    // Scratch-off fields
    ticketsPerBook: zod_1.z.number().int().min(1).optional(),
    // Common
    commissionRate: zod_1.z.number().min(0).max(1).default(0.05),
    maxPrizeClaimable: zod_1.z.number().int().min(0).default(59900).describe('Max claimable prize in cents'),
    isActive: zod_1.z.boolean().default(true),
    imageUrl: zod_1.z.string().optional(),
    sortOrder: zod_1.z.number().int().default(0),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLotteryGameCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(200),
    gameNumber: zod_1.z.string().min(1).max(50).optional(),
    upc: zod_1.z.string().optional(),
    ticketDirection: zod_1.z.enum(['up', 'down']).optional(),
    ticketPrice: zod_1.z.number().int().min(0),
    gameCategory: exports.APosLotteryGameCategorySchema,
    drawSchedule: exports.APosLotteryDrawScheduleSchema.optional(),
    drawDays: zod_1.z.array(zod_1.z.string()).optional(),
    drawTimes: zod_1.z.array(zod_1.z.string()).optional(),
    numberRange: exports.APosLotteryNumberRangeSchema.optional(),
    hasQuickPick: zod_1.z.boolean().optional(),
    hasBonusBall: zod_1.z.boolean().optional(),
    bonusRange: exports.APosLotteryNumberRangeSchema.optional(),
    ticketsPerBook: zod_1.z.number().int().min(1).optional(),
    commissionRate: zod_1.z.number().min(0).max(1).optional(),
    maxPrizeClaimable: zod_1.z.number().int().min(0).optional(),
    isActive: zod_1.z.boolean().optional(),
    imageUrl: zod_1.z.string().optional(),
    sortOrder: zod_1.z.number().int().optional(),
});
exports.APosLotteryGameUpdateInputSchema = exports.APosLotteryGameCreateInputSchema.partial();
//# sourceMappingURL=lottery-game.schema.js.map